export default __webpack_public_path__ + "static/media/profilecharacter.0b604bd7.png";